import { createSlice } from "@reduxjs/toolkit/"

let initialState = {
    recount:false
}
const recountSlice = createSlice({
    name:'recount',
    initialState,
    reducers:{
        setRecount:(state,{payload})=>{
            state.recount = payload
        },
    }
})

export const { setRecount } = recountSlice.actions
export default recountSlice.reducer